import { Card, Space, Button, Row, Col} from 'antd';
import { useEffect, useState } from 'react';
import {
  LoadingOutlined
} from '@ant-design/icons';
import BreadcrumbList from '../../../Shared/Components/Breadcrumb/Breadcrumb';
import './MedicaidMeetingDetails.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ServiceUtils } from '../../../Shared/Utils/ServiceUtils';
import { alertService } from '../../../Shared/Utils/ToasterUtils';

const MedicaidMeetingDetails = () => {
  const [meetingDetails, setMeetingDetails] = useState([]);
  const {id} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const filters = location?.state?.filters;

  useEffect(() => {
      fetchMeetingDetails();
  },[])

    const fetchMeetingDetails = () => {
    let payload = {
      id: id
    };

    ServiceUtils.postRequest("medicaidMeetingDetails", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let medMeetingsData = JSON.parse(
            JSON.stringify(response?.data?.data)
          );
          setMeetingDetails(medMeetingsData);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

    const columns = [
    {
      label: "Medicaid",
      link: "/home/medicaid",
    },
    {
      label: "Meeting Details",
      link: "",
    },
  ];
    return (
      <div className="medicaidMeetings">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>
        <Card
          style={{
            padding: "20px",
            height: "calc(100vh - 77px)",
            overflow: "auto",
          }}
        >
          <Row gutter={[16, 16]}>
            {meetingDetails?.meetingDetails?.values?.map((meet, index) => {
              return (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <div style={{ display: "grid" }}>
                    <label className="form-label text-ellipsis-one-line">
                      {meet?.key}
                    </label>
                    {meet.type === "url" ? (
                      <label
                        onClick={() => window.open(meet?.value, "blank")}
                        className="text-only text-ellipsis-one-line link"
                      >
                        {meet?.value || "-"}
                      </label>
                    ) : (
                      <label className="text-only text-ellipsis-one-line">
                        {meet?.value || "-"}
                      </label>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
          <Row gutter={[16, 16]}>
            {meetingDetails?.meetingClasses?.values?.map((meet, index) => {
              return (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <div style={{ display: "grid" }}>
                    <label className="form-label text-ellipsis-one-line">
                      {meet?.key}
                    </label>
                    <label
                      className="text-only"
                      style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    >
                      {meet?.values?.length ? meet?.values.join(", ") : "-"}
                    </label>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Card>
      </div>
    );
}

export default MedicaidMeetingDetails;